import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';

import Table from '../Table/Table';

import { getSupervisaoMaintenance } from '../Api/Api';

export default function OpenedNCsModal({ show, handleClose, date }) {
  const [list, setList] = useState({});

  const columns = [
    {
      title: 'NC',
      data: 'system_maintenance_id',
      className: 'text-center',
      orderable: false,
      render: function (data) {
        return `#` + data.toString().padStart(5, '0');
      },
    },
    {
      title: 'Registrado',
      data: 'open_time_created',
      className: 'text-center',
      orderable: false,
    },
    {
      title: 'Sistema',
      data: 'system_type_name',
      className: 'text-center',
      orderable: false,
    },
    {
      title: 'Problema',
      data: 'system_maintenance_text',
      orderable: false,
      width: '40%',
    },
    {
      title: 'Data do registro',
      data: 'system_maintenance_created_formatted',
      className: 'text-center',
      orderable: false,
    },
    {
      title: 'Última tratativa',
      data: 'maintenance_warning_text',
      orderable: false,
      width: '40%',
    },
    {
      title: 'Última tratativa (data)',
      data: 'maintenance_warning_date',
      className: 'text-center',
      orderable: false,
    },
    {
      title: 'Prioridade',
      data: 'maintenance_type_priority',
      className: 'text-center',
      orderable: false,
      render: (data) => {
        let badgeClass = 'badge badge-light';

        if (data == 'Urgente') {
          badgeClass = 'badge bg-danger urgents';
        } else if (data == 'Crítica') {
          badgeClass = 'badge bg-danger criticals';
        }

        return `<span class="${badgeClass}">${data}</span>`;
      },
    },
    {
      title: '',
      data: null,
      visible: false,
    },
  ];

  const actionButtonsDefault = (row) => {
    return <></>;
  };

  const loadOpenedNCs = async () => {
    const res = await getSupervisaoMaintenance({ return_list: true });
    if (res.data) {
      setList(res.data);
    }
  };

  useEffect(() => {
    loadOpenedNCs();
  }, []);

  return (
    <Modal show={show} size="xl" onHide={handleClose}>
      <div id="modalSupervision">
        <Modal.Header className="text-center bg-red-default" closeButton>
          <Modal.Title className="w-100">
            <span>Listagem de NCs em aberto ({date})</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="scrollAxis">
              <Table
                data={list}
                columns={columns}
                btnColumn={8}
                actBtns={actionButtonsDefault}
              />
            </div>
          </div>
        </Modal.Body>
      </div>
      <Modal.Footer>
        <Button variant="warning" onClick={loadOpenedNCs}>
          Atualizar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
